import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { tags } from "../../../constants";

export enum YesNo {
  Y = "Y",
  N = "N",
}
export type Tag = (typeof tags)[number];
export type TagCombination<T extends Tag> = T[] | [`${T}`];
export enum Status {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
export enum ContentType {
  TILE = "TILE",
  DASHBOARD = "DASHBOARD",
  REPORT = "REPORT",
}

export enum ReportType {
  STANDARD = "STANDARD",
  CUSTOM = "CUSTOM",
}

export type SubscriptionStatus = {
  status: string;
  clientCode: string;
};

export type Content = {
  allProducts: string[];
  subscriptionStatus: SubscriptionStatus;
  subscriptionType: string;
  dashboardId: string;
  visualId: string;
  sheetId: string;
  status: Status;
  contentType: ContentType;
  clientCode: string;
  coldStartInd: YesNo;
  phiInd: boolean;
  piiInd: boolean;
  title: string;
  description: string;
  reportType: ReportType;
  persona: string;
  productId: string[];
  contentId: string;
  comment: string;
  width: string;
  height: string;
  tags: any[];
  pinInd: string;
  shared?: string; // 'Y' or 'N'
  userId?: string;
  contentVisibility?: string;
};

export type Update = {};

@Injectable({
  providedIn: "root",
})
export class ContentService {
  private API_URL: string;
  constructor(private http: HttpClient, @Inject("API_URL") apiUrl: string) {
    this.API_URL = apiUrl;
  }

  getContent(): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/admin/content`);
  }

  createContent(body: Content): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/admin/content`, body);
  }

  updateContent(updateBody: Update): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/admin/content`, updateBody);
  }

  syncContent(dashboardId: string, clientCode: string): Observable<any> {
    const body = {
      dashboardId: dashboardId,
      clientCode: clientCode
    };
    return this.http.post<any>(`${this.API_URL}/admin/manage-content/sync-all`, body);
  }
}
